export {
  IPhotoLabelSchema as IPhotoLabel,
  EColor,
} from 'shared/repositories/search-engine/entities/media/PhotoLabelSchema';

export enum EMediaType {
  CianLayout = 'cianLayout',
  Layout = 'layout',
  Photo = 'photo',
  Video = 'video',
}

export interface IMedia {
  type: EMediaType;
  src: string;
  previewUrl?: string;
}
